import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { makeObservable, observable, reaction, runInAction } from "mobx";
import Base from "./Base";
import DPServices from "@dp/services";
import PrivateDiningModel from "./models/PrivateDiningModel";
import moment from "moment-timezone";
import i18next from "i18next";
import { isTrue } from "@dp/common";
var PrivateDining = (_class = /*#__PURE__*/function (_Base) {
  _inherits(PrivateDining, _Base);

  var _super = _createSuper(PrivateDining);

  function PrivateDining(rootStore) {
    var _this;

    _classCallCheck(this, PrivateDining);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "privateDiningModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor2, _assertThisInitialized(_this));

    _this.rootStore = rootStore;
    _this.privateDiningModel = new PrivateDiningModel(_this.rootStore.platformUtil);

    _this.rootStore.user.analyticsModel.setChangeErrorPageNameWithoutRD(true);

    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PrivateDining, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = session;

        _this2.privateDiningModel.setSessionDetails(session);
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._appAttributes = appAttributes;
                this.privateDiningModel.setAppAttributesData(appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processAppAttributes(_x) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore,
            _this$rootStore$menuL,
            _this$rootStore$menuL2,
            _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

                this.privateDiningModel.selectedRestDetails = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$menuL = _this$rootStore.menuList) === null || _this$rootStore$menuL === void 0 ? void 0 : (_this$rootStore$menuL2 = _this$rootStore$menuL.orderSettingsModel) === null || _this$rootStore$menuL2 === void 0 ? void 0 : _this$rootStore$menuL2.currentRestaurant;
                runInAction(function () {
                  var _this3$rootStore, _this3$rootStore$user;

                  _this3.privateDiningModel.setUserData((_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$user = _this3$rootStore.user) === null || _this3$rootStore$user === void 0 ? void 0 : _this3$rootStore$user.userProfile);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function refresh() {
      return Promise.resolve();
    }
  }, {
    key: "reset",
    value: function reset() {
      return Promise.resolve();
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this4 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this4.rootStore.common.appAttributes
        };
      }, function (data) {
        _this4._processAppAttributes(data.appAttributes);
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this4.rootStore.user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4._processSessionDetails(data.sessionDetails);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()); // user profile

      reaction(function () {
        var _this4$rootStore, _this4$rootStore$user;

        return {
          userProfile: (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : (_this4$rootStore$user = _this4$rootStore.user) === null || _this4$rootStore$user === void 0 ? void 0 : _this4$rootStore$user.userProfile
        };
      }, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this4.privateDiningModel.setUserData(data === null || data === void 0 ? void 0 : data.userProfile);

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }()); // Restaurant Details

      reaction(function () {
        var _this4$rootStore2, _this4$rootStore2$men, _this4$rootStore2$men2;

        return {
          restaurantDetails: (_this4$rootStore2 = _this4.rootStore) === null || _this4$rootStore2 === void 0 ? void 0 : (_this4$rootStore2$men = _this4$rootStore2.menuList) === null || _this4$rootStore2$men === void 0 ? void 0 : (_this4$rootStore2$men2 = _this4$rootStore2$men.orderSettingsModel) === null || _this4$rootStore2$men2 === void 0 ? void 0 : _this4$rootStore2$men2.currentRestaurant
        };
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this4.privateDiningModel.selectedRestDetails = data === null || data === void 0 ? void 0 : data.restaurantDetails;
                  _this4.privateDiningModel.isChangeLocationModalOpen = false;

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "createPrivateDining",
    value: function () {
      var _createPrivateDining = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _dob$split,
            _dob$split2,
            _dob$split3,
            _this$_appAttributes,
            _this$_appAttributes2,
            _this$_appAttributes3,
            _this$privateDiningMo,
            _this$privateDiningMo2,
            _this$_sessionDetails,
            _this$_sessionDetails2,
            _this5 = this;

        var pdModel, dob, dateOfBirth, userDetail, subscription, timeSlot, payload, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                pdModel = this.privateDiningModel;
                pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(true);
                dob = pdModel === null || pdModel === void 0 ? void 0 : pdModel.dob;
                dateOfBirth = dob ? {
                  dobDay: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split = dob.split("/")) === null || _dob$split === void 0 ? void 0 : _dob$split[1]),
                  dobMonth: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split2 = dob.split("/")) === null || _dob$split2 === void 0 ? void 0 : _dob$split2[0]),
                  dobYear: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split3 = dob.split("/")) === null || _dob$split3 === void 0 ? void 0 : _dob$split3[2])
                } : undefined;
                userDetail = {
                  firstName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.firstName,
                  lastName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.lastName,
                  email: pdModel === null || pdModel === void 0 ? void 0 : pdModel.email,
                  phoneNumber: pdModel === null || pdModel === void 0 ? void 0 : pdModel.phone,
                  dateOfBirth: dateOfBirth
                };
                subscription = pdModel !== null && pdModel !== void 0 && pdModel.eclubOption ? {
                  type: "subscription",
                  preferenceName: (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode,
                  signupSource: "".concat((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.currentConceptCode) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.toLocaleLowerCase(), "_private_dining"),
                  subscriptionStatus: "P",
                  secondarySubscriptions: pdModel === null || pdModel === void 0 ? void 0 : pdModel.secondarySubscriptions
                } : undefined;
                timeSlot = {
                  reservationTime: pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInTime,
                  reservationDate: moment(pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInDate).format("MM/DD/YYYY")
                };
                payload = {
                  restaurantNum: ((_this$privateDiningMo = this.privateDiningModel) === null || _this$privateDiningMo === void 0 ? void 0 : (_this$privateDiningMo2 = _this$privateDiningMo.selectedRestDetails) === null || _this$privateDiningMo2 === void 0 ? void 0 : _this$privateDiningMo2.restaurantNumber) || ((_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.restaurantNumber),
                  userDetail: userDetail,
                  subscription: subscription,
                  timeSlot: timeSlot,
                  partySize: parseInt(pdModel !== null && pdModel !== void 0 && pdModel.isGroupDiningSupported ? pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedPartySize : pdModel === null || pdModel === void 0 ? void 0 : pdModel.noOfGuests),
                  comments: pdModel === null || pdModel === void 0 ? void 0 : pdModel.specialRequests,
                  companyName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.company,
                  purpose: pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedPurpose,
                  privateDiningCheck: "Single-Check",
                  eclubOptin: pdModel === null || pdModel === void 0 ? void 0 : pdModel.eclubOption
                };
                _context6.next = 10;
                return DPServices.PrivateDining.requestPrivateDining(payload).then(function () {
                  _this5._dispatchFormSubmitSuccessEvent();

                  _this5._dispatchEclubOnSubmitSuccessEvent();

                  _this5.privateDiningModel.setShowConfirmationPage(true);

                  pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(false);

                  _this5.goToPDConfirmation();
                })["catch"](function (error) {
                  pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(false);

                  _this5._proccessError(false, error);
                });

              case 10:
                data = _context6.sent;
                return _context6.abrupt("return", data);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createPrivateDining() {
        return _createPrivateDining.apply(this, arguments);
      }

      return createPrivateDining;
    }()
  }, {
    key: "createGroupDining",
    value: function () {
      var _createGroupDining = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _dob$split4,
            _dob$split5,
            _dob$split6,
            _this$_appAttributes4,
            _this$_appAttributes5,
            _this$_appAttributes6,
            _this$privateDiningMo3,
            _this$privateDiningMo4,
            _this$_sessionDetails3,
            _this$_sessionDetails4,
            _this6 = this;

        var pdModel, dob, dateOfBirth, userDetail, subscription, timeSlot, payload, data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                pdModel = this.privateDiningModel;
                pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(true);
                dob = pdModel === null || pdModel === void 0 ? void 0 : pdModel.dob;
                dateOfBirth = dob ? {
                  dobDay: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split4 = dob.split("/")) === null || _dob$split4 === void 0 ? void 0 : _dob$split4[1]),
                  dobMonth: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split5 = dob.split("/")) === null || _dob$split5 === void 0 ? void 0 : _dob$split5[0]),
                  dobYear: parseInt(dob === null || dob === void 0 ? void 0 : (_dob$split6 = dob.split("/")) === null || _dob$split6 === void 0 ? void 0 : _dob$split6[2])
                } : undefined;
                userDetail = {
                  firstName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.firstName,
                  lastName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.lastName,
                  email: pdModel === null || pdModel === void 0 ? void 0 : pdModel.email,
                  phoneNumber: pdModel === null || pdModel === void 0 ? void 0 : pdModel.phone,
                  dateOfBirth: dateOfBirth
                };
                subscription = pdModel !== null && pdModel !== void 0 && pdModel.eclubOption ? {
                  type: "subscription",
                  preferenceName: (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.currentConceptCode,
                  signupSource: "".concat((_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.currentConceptCode) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.toLocaleLowerCase(), "_private_dining"),
                  subscriptionStatus: "P",
                  secondarySubscriptions: pdModel === null || pdModel === void 0 ? void 0 : pdModel.secondarySubscriptions
                } : undefined;
                timeSlot = {
                  reservationTime: pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInTime,
                  reservationDate: moment(pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInDate).format("MM/DD/YYYY")
                };
                payload = {
                  restaurantNum: ((_this$privateDiningMo3 = this.privateDiningModel) === null || _this$privateDiningMo3 === void 0 ? void 0 : (_this$privateDiningMo4 = _this$privateDiningMo3.selectedRestDetails) === null || _this$privateDiningMo4 === void 0 ? void 0 : _this$privateDiningMo4.restaurantNumber) || ((_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.restaurantDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.restaurantNumber),
                  partySize: pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedPartySize,
                  timeSlot: timeSlot,
                  zipCode: parseInt(pdModel === null || pdModel === void 0 ? void 0 : pdModel.zipCode),
                  comments: pdModel === null || pdModel === void 0 ? void 0 : pdModel.specialRequests,
                  companyName: pdModel === null || pdModel === void 0 ? void 0 : pdModel.company,
                  userDetail: userDetail,
                  subscription: subscription,
                  privateDiningCheck: "Single-Check",
                  eclubOptin: pdModel === null || pdModel === void 0 ? void 0 : pdModel.eclubOption
                };
                _context7.next = 10;
                return DPServices.PrivateDining.requestGroupDining(payload).then(function () {
                  _this6._dispatchFormSubmitSuccessEvent();

                  _this6.privateDiningModel.setShowConfirmationPage(true);

                  pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(false);

                  _this6.goToPDConfirmation();
                })["catch"](function (error) {
                  pdModel === null || pdModel === void 0 ? void 0 : pdModel.setIsPrivateDiningSubmiting(false);

                  _this6._proccessError(true, error);
                });

              case 10:
                data = _context7.sent;
                return _context7.abrupt("return", data);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function createGroupDining() {
        return _createGroupDining.apply(this, arguments);
      }

      return createGroupDining;
    }()
  }, {
    key: "getPrivateDiningRestuarants",
    value: function () {
      var _getPrivateDiningRestuarants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(restaurantNumber) {
        var _this7 = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                this.privateDiningModel.isLocationsListLoading = true;
                _context8.next = 4;
                return DPServices.PrivateDining.getPrivateDiningRestuarants();

              case 4:
                data = _context8.sent;
                this.privateDiningModel.locationsList = data;
                this.privateDiningModel.isLocationsListLoading = false;
                _context8.next = 13;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                this.privateDiningModel.isLocationsListLoading = false;
                this.rootStore.appMessages.showError(i18next.t("text.private_dining_location.error_title", {
                  defaultValue: "Error"
                }), i18next.t("text.private_dining_location.error_message", {
                  defaultValue: "Unable to fetch restaurants."
                }), null, {
                  undismissible: true,
                  okBtnText: "Go to Home",
                  okBtnOnClick: function okBtnOnClick() {
                    _this7.rootStore.platformUtil.navigateToRoute("/home");
                  }
                });

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function getPrivateDiningRestuarants(_x5) {
        return _getPrivateDiningRestuarants.apply(this, arguments);
      }

      return getPrivateDiningRestuarants;
    }()
  }, {
    key: "checkForLocationModal",
    value: function checkForLocationModal() {
      var _this$_sessionDetails5, _this$_sessionDetails6, _this$privateDiningMo5, _this$privateDiningMo6;

      if (!((_this$_sessionDetails5 = this._sessionDetails) !== null && _this$_sessionDetails5 !== void 0 && (_this$_sessionDetails6 = _this$_sessionDetails5.restaurantDetails) !== null && _this$_sessionDetails6 !== void 0 && _this$_sessionDetails6.restaurantNumber) || !((_this$privateDiningMo5 = this.privateDiningModel) !== null && _this$privateDiningMo5 !== void 0 && (_this$privateDiningMo6 = _this$privateDiningMo5.selectedRestDetails) !== null && _this$privateDiningMo6 !== void 0 && _this$privateDiningMo6.restaurantNumber)) {
        this.privateDiningModel.isChangeLocationModalOpen = true;
      } else {
        this.privateDiningModel.isChangeLocationModalOpen = false;
      }
    }
  }, {
    key: "selectLocation",
    value: function () {
      var _selectLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(restaurantNum) {
        var _this$rootStore2, _this$rootStore2$menu;

        var result, _this$privateDiningMo7;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$menu = _this$rootStore2.menuList) === null || _this$rootStore2$menu === void 0 ? void 0 : _this$rootStore2$menu.selectRestaurant(restaurantNum);

              case 2:
                result = _context9.sent;

                if (result) {
                  this.privateDiningModel.isChangeLocationModalOpen = false;
                  this.privateDiningModel.setSelectedDineInDate("");
                  this.privateDiningModel.setSelectedDineInTime("");
                  (_this$privateDiningMo7 = this.privateDiningModel) === null || _this$privateDiningMo7 === void 0 ? void 0 : _this$privateDiningMo7.setIsEventDetailsFormChanged({
                    selectedDineInDate: false,
                    selectedDineInTime: false,
                    noOfGuests: false,
                    selectedPurpose: false,
                    selectedPartySize: false
                  });
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function selectLocation(_x6) {
        return _selectLocation.apply(this, arguments);
      }

      return selectLocation;
    }()
  }, {
    key: "goToPDHome",
    value: function () {
      var _goToPDHome = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this$privateDiningMo8;

        var privateDiningURLPath, url;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                privateDiningURLPath = (_this$privateDiningMo8 = this.privateDiningModel) === null || _this$privateDiningMo8 === void 0 ? void 0 : _this$privateDiningMo8.privateDiningURLPath;
                url = i18next.t("link.private_dining.go_to_home_url", {
                  defaultValue: "".concat(privateDiningURLPath, "/home")
                });
                this.rootStore.platformUtil.navigateToRoute(url);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function goToPDHome() {
        return _goToPDHome.apply(this, arguments);
      }

      return goToPDHome;
    }()
  }, {
    key: "goToPDConfirmation",
    value: function () {
      var _goToPDConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var url;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                url = i18next.t("link.private_dining.go_to_confirmation_url", {
                  defaultValue: "/private-dining/confirmation"
                });
                this.rootStore.platformUtil.navigateToRoute(url);

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function goToPDConfirmation() {
        return _goToPDConfirmation.apply(this, arguments);
      }

      return goToPDConfirmation;
    }()
  }, {
    key: "getContentIDsByPageType",
    value: function getContentIDsByPageType(pageType) {
      var _this$privateDiningMo9, _this$privateDiningMo10, _this$privateDiningMo11, _config$content, _config$content$conte;

      var config = (_this$privateDiningMo9 = this.privateDiningModel) === null || _this$privateDiningMo9 === void 0 ? void 0 : (_this$privateDiningMo10 = _this$privateDiningMo9.privateDiningConfigs) === null || _this$privateDiningMo10 === void 0 ? void 0 : (_this$privateDiningMo11 = _this$privateDiningMo10.filter(function (config) {
        var _config$pageType, _config$pageType$toLo;

        return config === null || config === void 0 ? void 0 : (_config$pageType = config.pageType) === null || _config$pageType === void 0 ? void 0 : (_config$pageType$toLo = _config$pageType.toLowerCase()) === null || _config$pageType$toLo === void 0 ? void 0 : _config$pageType$toLo.includes(pageType);
      })) === null || _this$privateDiningMo11 === void 0 ? void 0 : _this$privateDiningMo11[0];

      if ((config === null || config === void 0 ? void 0 : (_config$content = config.content) === null || _config$content === void 0 ? void 0 : (_config$content$conte = _config$content.contentIds) === null || _config$content$conte === void 0 ? void 0 : _config$content$conte.length) > 0) {
        var _config$content2;

        return config === null || config === void 0 ? void 0 : (_config$content2 = config.content) === null || _config$content2 === void 0 ? void 0 : _config$content2.contentIds;
      }

      return [];
    }
  }, {
    key: "getPageContentWithIDs",
    value: function () {
      var _getPageContentWithIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(contentIds) {
        var _this8 = this;

        var _this$privateDiningMo12, _this$privateDiningMo13, _this$_sessionDetails7, _this$_sessionDetails8, _this$privateDiningMo14, data;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return DPServices.PrivateDining.fetchPageContent(contentIds, ((_this$privateDiningMo12 = this.privateDiningModel) === null || _this$privateDiningMo12 === void 0 ? void 0 : (_this$privateDiningMo13 = _this$privateDiningMo12.selectedRestDetails) === null || _this$privateDiningMo13 === void 0 ? void 0 : _this$privateDiningMo13.restaurantNumber) || ((_this$_sessionDetails7 = this._sessionDetails) === null || _this$_sessionDetails7 === void 0 ? void 0 : (_this$_sessionDetails8 = _this$_sessionDetails7.restaurantDetails) === null || _this$_sessionDetails8 === void 0 ? void 0 : _this$_sessionDetails8.restaurantNumber));

              case 3:
                data = _context12.sent;
                (_this$privateDiningMo14 = this.privateDiningModel) === null || _this$privateDiningMo14 === void 0 ? void 0 : _this$privateDiningMo14.setPageContent(data === null || data === void 0 ? void 0 : data.contentIds);
                _context12.next = 10;
                break;

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);
                this.rootStore.appMessages.showError("Something went wrong.", "Unable to load Content", null, {
                  undismissible: false,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    _this8.goToPDHome();
                  }
                });

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 7]]);
      }));

      function getPageContentWithIDs(_x7) {
        return _getPageContentWithIDs.apply(this, arguments);
      }

      return getPageContentWithIDs;
    }()
  }, {
    key: "_proccessError",
    value: function _proccessError(isGroupDining, error) {
      var _this9 = this;

      var title = isTrue(isGroupDining, i18next.t("text.create_group_dining.error_title", {
        defaultValue: "Error"
      }), i18next.t("text.create_private_dining.error_title", {
        defaultValue: "Error"
      }));
      var subTitle = isTrue(isGroupDining, i18next.t("text.create_group_dining.error_message", {
        defaultValue: "Unable to create group dining. \nGo back to Private Dining Home"
      }), i18next.t("text.create_private_dining.error_message", {
        defaultValue: "Unable to create private dining. \nGo back to Private Dining Home"
      }));

      if (error instanceof DPServices.Errors.UIError) {
        var _error$errors, _error$errors$, _error$errors2, _error$errors2$, _error$errors3, _error$errors3$;

        subTitle = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.message;

        this._dispatchFormErrorEvent(error === null || error === void 0 ? void 0 : (_error$errors2 = error.errors) === null || _error$errors2 === void 0 ? void 0 : (_error$errors2$ = _error$errors2[0]) === null || _error$errors2$ === void 0 ? void 0 : _error$errors2$.message, error === null || error === void 0 ? void 0 : (_error$errors3 = error.errors) === null || _error$errors3 === void 0 ? void 0 : (_error$errors3$ = _error$errors3[0]) === null || _error$errors3$ === void 0 ? void 0 : _error$errors3$.code);
      }

      this.rootStore.appMessages.showError(title, subTitle, null, {
        undismissible: false,
        okBtnText: "Ok",
        okBtnOnClick: function okBtnOnClick() {
          _this9.goToPDHome();
        }
      });
    }
  }, {
    key: "_dispatchFormSubmitSuccessEvent",
    value: function _dispatchFormSubmitSuccessEvent() {
      var _this$rootStore3, _this$rootStore3$plat;

      var privateDiningURLPath = this.privateDiningModel.privateDiningURLPath;

      var getFormType = function getFormType() {
        if (privateDiningURLPath !== null && privateDiningURLPath !== void 0 && privateDiningURLPath.includes("group")) return "group dining";else if (privateDiningURLPath !== null && privateDiningURLPath !== void 0 && privateDiningURLPath.includes("events")) return "private events";else return "private dining";
      };

      var payload = {
        formType: getFormType()
      };
      (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$plat = _this$rootStore3.platformUtil) === null || _this$rootStore3$plat === void 0 ? void 0 : _this$rootStore3$plat.dispatchEvent("AnalyticsEvent", "Form Submit", payload);
    }
  }, {
    key: "_dispatchEclubOnSubmitSuccessEvent",
    value: function _dispatchEclubOnSubmitSuccessEvent() {
      var _this$privateDiningMo15;

      if ((_this$privateDiningMo15 = this.privateDiningModel) !== null && _this$privateDiningMo15 !== void 0 && _this$privateDiningMo15.eclubOption) {
        var _this$privateDiningMo16, _this$privateDiningMo17, _this$rootStore4, _this$rootStore4$plat, _this$privateDiningMo18;

        var conceptCode = this._appAttributes.currentConceptCode;
        var signUpSourcePageType = (_this$privateDiningMo16 = this.privateDiningModel) !== null && _this$privateDiningMo16 !== void 0 && (_this$privateDiningMo17 = _this$privateDiningMo16.privateDiningURLPath) !== null && _this$privateDiningMo17 !== void 0 && _this$privateDiningMo17.includes("group") ? "groupDining" : "privateDining";
        var signUpSrc = i18next.t("privateDining.signup_source", {
          defaultValue: "".concat(conceptCode.toLowerCase(), "_signup_").concat(signUpSourcePageType)
        });
        (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$plat = _this$rootStore4.platformUtil) === null || _this$rootStore4$plat === void 0 ? void 0 : _this$rootStore4$plat.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {
          brands: (_this$privateDiningMo18 = this.privateDiningModel) === null || _this$privateDiningMo18 === void 0 ? void 0 : _this$privateDiningMo18.secondarySubscriptions,
          signupChannel: signUpSrc
        });
      }
    }
  }, {
    key: "_dispatchFormErrorEvent",
    value: function _dispatchFormErrorEvent(faultDescription, faultCode) {
      var _this$rootStore5, _this$rootStore5$plat;

      (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$plat = _this$rootStore5.platformUtil) === null || _this$rootStore5$plat === void 0 ? void 0 : _this$rootStore5$plat.dispatchEvent("AnalyticsEvent", "ErrorCode", {
        faultDescription: faultDescription,
        faultCode: faultCode
      });
    }
  }, {
    key: "dispatchPrivateDiningRequestSuccess",
    value: function dispatchPrivateDiningRequestSuccess() {
      var _pdModel$specialReque, _this$rootStore6, _this$rootStore6$plat;

      var pdModel = this === null || this === void 0 ? void 0 : this.privateDiningModel;
      var date = moment(pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInDate).format("YYYY-MM-DD");
      var day = moment(pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInDate).format("dddd");
      var selectTime = pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedDineInTime;
      var numberOfGuests = pdModel !== null && pdModel !== void 0 && pdModel.isGroupDiningSupported ? pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedPartySize : pdModel === null || pdModel === void 0 ? void 0 : pdModel.noOfGuests;
      var purpose = pdModel === null || pdModel === void 0 ? void 0 : pdModel.selectedPurpose;
      var specialInstructions = (_pdModel$specialReque = pdModel === null || pdModel === void 0 ? void 0 : pdModel.specialRequests) !== null && _pdModel$specialReque !== void 0 ? _pdModel$specialReque : "";
      (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$plat = _this$rootStore6.platformUtil) === null || _this$rootStore6$plat === void 0 ? void 0 : _this$rootStore6$plat.dispatchEvent("AnalyticsEvent", "Private Dining Request Success", {
        date: date,
        day: day,
        selectTime: selectTime,
        numberOfGuests: numberOfGuests,
        purpose: purpose,
        specialInstructions: specialInstructions
      });
    }
  }, {
    key: "dispathPageViewEvent",
    value: function dispathPageViewEvent(currentRoute) {
      var _this$rootStore7, _this$rootStore7$plat, _currentRoute$split, _currentRoute$split$s;

      (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.dispatchEvent("AnalyticsEvent", "PageView", {
        pageName: "".concat(currentRoute === null || currentRoute === void 0 ? void 0 : (_currentRoute$split = currentRoute.split("/")) === null || _currentRoute$split === void 0 ? void 0 : (_currentRoute$split$s = _currentRoute$split.slice(1)) === null || _currentRoute$split$s === void 0 ? void 0 : _currentRoute$split$s.join(" "))
      });
    }
  }, {
    key: "fetchTimeSlotsForSelectedDate",
    value: function () {
      var _fetchTimeSlotsForSelectedDate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _DPServices$PrivateDi, _this$privateDiningMo19, _this$privateDiningMo20;

        var date, restDetails;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                // call RD API
                date = moment(this.privateDiningModel.selectedDineInDate).format("MM-DD-YYYY");
                _context13.next = 3;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$PrivateDi = DPServices.PrivateDining) === null || _DPServices$PrivateDi === void 0 ? void 0 : _DPServices$PrivateDi.fetchTimeSLotsForSelectedDate((_this$privateDiningMo19 = this.privateDiningModel) === null || _this$privateDiningMo19 === void 0 ? void 0 : (_this$privateDiningMo20 = _this$privateDiningMo19.selectedRestDetails) === null || _this$privateDiningMo20 === void 0 ? void 0 : _this$privateDiningMo20.restaurantNumber, date);

              case 3:
                restDetails = _context13.sent;
                this.privateDiningModel.selectedRestDetails = restDetails;

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function fetchTimeSlotsForSelectedDate() {
        return _fetchTimeSlotsForSelectedDate.apply(this, arguments);
      }

      return fetchTimeSlotsForSelectedDate;
    }()
  }]);

  return PrivateDining;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { PrivateDining as default };